<hpf-activity-log-form
	[activityLog]="activityLog"
	[loading]="activityLog.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-activity-log-form>
